var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"col btn",attrs:{"href":"javascript:void(0)","title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon-base',{attrs:{"icon-color":'#1e88e5'}},[_c('inner-svg')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }